import {
  CircularProgress,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  Button,
  Typography,
} from "@mui/material";
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import React from "react";
import { AddInstrumentModalController, AddInstrumentModalControllerDelegate, IAssignment } from "./controller";

interface State {
  isLoading: boolean;
  assignments: IAssignment[];
  selectedAssignments: number[];
  errors: {
    insufficientLicenses: boolean;
  }
}

interface Props {
  userUid?: string;
  delegate: AddInstrumentModalDelegate;
}

export interface AddInstrumentModalDelegate {
  shouldCloseModal: () => void;
  applicationShouldLogout: () => void;
  genericError: () => void;
  didAddAssignments: () => void;
}

class AddInstrumentModal extends React.Component<Props, State> implements AddInstrumentModalControllerDelegate {

  controller: AddInstrumentModalController

  constructor(props: Props) {
    super(props);
    this.state = {
      isLoading: true,
      assignments: [],
      selectedAssignments: [],
      errors: {
        insufficientLicenses: false
      }
    }
    this.controller = new AddInstrumentModalController(this);
  }

  // delegate
  didGetAssignments(assignments: IAssignment[]) {
    this.setState({
      isLoading: false,
      assignments
    });
  }

  insufficientLicensesError() {
    this.setState({
      isLoading: false,
      errors: {
        insufficientLicenses: true
      }
    })
  }

  didAddAssignments(){
    this.props.delegate.didAddAssignments();
  }

  genericError() {
    this.props.delegate.genericError();
  };

  applicationShouldLogout() {
    this.props.delegate.applicationShouldLogout();
  };

  // internals

  handleChangeSelected(event: any): void {
    this.setState({
      selectedAssignments: [...event.target.value]
    })
  }

  componentDidMount(): void {
    const token = localStorage.getItem("AccessToken")!;
    this.controller.getManagedAssignments(token);
  }

  didClickClose() {
    this.props.delegate.shouldCloseModal();
  }

  didClickAddInstruments() {
    this.setState({
      isLoading: true
    });
    const token = localStorage.getItem("AccessToken")!;
    const userUid = this.props.userUid!;
    const idsToAdd = this.state.selectedAssignments.map(selected => {
      return this.state.assignments[selected].applicationId;
    });
    this.controller.addAssignmentsToUser(token, userUid, idsToAdd);
  }

  renderLoading() {
    return (
      <Box
        alignItems="center"
        display="flex"
        flexDirection="column"
        marginTop={2}
      >
        <CircularProgress />
      </Box>
    );
  }

  renderForm() {
    const options = this.state.assignments.map((assignment, index) => {
      return (
        <MenuItem
          value={index}
          key={`available_assignment_${index}`}
        >
          <Checkbox checked={this.state.selectedAssignments.indexOf(index) >= 0}/>
          {`${assignment.title} (${assignment.instrumentTitle})`}
        </MenuItem>
      )
    });

    return (
      <Box display="flex" flexDirection="column" sx={{ gap: 2 }}>
        <Typography color="text.secondary">
          Selecione as aplicações que deseja adicionar ao usuário.
        </Typography>
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Aplicações</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            label="Aplicações"
            multiple
            value={this.state.selectedAssignments}
            renderValue={
              (itens) => itens
                .map(item => this.state.assignments[item].title)
                .join(",")
            }
            onChange={(event) => this.handleChangeSelected(event)}
          >
            { options }
          </Select>
        </FormControl>
        
      </Box>
    );
  }

  renderInssuficientLicenses() {
    return (
      <Box display="flex" flexDirection="column">
        <Typography color="error" align="center" alignSelf="center" fontWeight="bold">ERRO</Typography>
        <Typography color="error" alignSelf="center">Você não possui licenças disponíveis para todos os instrumentos selecionados e por isso não pode atribuir as aplicações.</Typography>
        <Button
          variant="outlined"
          color="error"
          onClick={() => {
            this.props.delegate.shouldCloseModal()
          }}
        >
          Voltar
        </Button>
      </Box>
    )
  }

  // Internals
  render() {
    let dataToRender;
    if(this.state.isLoading) {
      dataToRender = this.renderLoading()
    } else if (this.state.errors.insufficientLicenses) {
      dataToRender = this.renderInssuficientLicenses()
    } else {
      dataToRender = this.renderForm()
    }

    return (
      <Dialog
        open={!!this.props.userUid}
        onClose={() => this.didClickClose()}
        variant="modal"
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle variant="modal">
          <NoteAddIcon/>
          Adicionar aplicações
        </DialogTitle>
        <DialogContent variant="modal">
          {dataToRender}
        </DialogContent>
        {!this.state.isLoading && !this.state.errors.insufficientLicenses && (
          <DialogActions
            variant="modal"
            sx={{ flexWrap: "wrap", gap: 1, justifyContent: "end" }}
          >
            <Button
              variant="outlined"
              color="error"
              onClick={() => {
                this.props.delegate.shouldCloseModal()
              }}
            >
              Voltar
            </Button>

            <Button
              variant="contained"
              onClick={() => this.didClickAddInstruments()}
              disabled={this.state.selectedAssignments.length === 0}
            >
              Adicionar Aplicações
            </Button>
          </DialogActions>
        )}
      </Dialog>
    );
  }
}

export default AddInstrumentModal;
